<app-page-shell variant="default">
  <div class="card card-box sb-sticky-actions-host mb-5">
    <div class="card-header py-3">
      <div class="card-header--title font-size-lg">Share Widget Auto Access</div>
    </div>
    @if (project()) {
    <div class="card-body">
      <app-sb-tabs queryParam="tab">
        <!-- One tab component; each method keeps its own settings. -->
        <ng-template sbTab="join-url" title="Join/Update Via URL">
          <app-share-widget-access-tab
            method="join"
            [projectId]="projectId"
            [project]="project()"
          ></app-share-widget-access-tab>
        </ng-template>
        <ng-template sbTab="email" title="Access/Update via Email in URL">
          <app-share-widget-access-tab
            method="email"
            [projectId]="projectId"
            [project]="project()"
          ></app-share-widget-access-tab>
        </ng-template>
        <ng-template sbTab="sso" title="SSO">
          <app-share-widget-access-tab
            method="sso"
            [projectId]="projectId"
            [project]="project()"
          ></app-share-widget-access-tab>
        </ng-template>
      </app-sb-tabs>
    </div>
    }
  </div>
</app-page-shell>
